"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Face_vue_1 = require("./Face.vue");
exports.default = Face_vue_1.default;
